import React from 'react';
import "./index.css";

function Footer() {
    return(<>
        <footer>
            <h4>수업에 대한 문의/상담은 010-6254-7396 또는 031-981-8951으로 주세요.</h4>
        </footer>

</>
    )};

export default Footer;